<template>
  <div v-if="item" class="hub-preview">
    <div v-if="showId" class="hub-preview-row">
      <span class="hub-preview-key">ID</span>
      <button
        v-if="item.id"
        type="button"
        class="hub-preview-value copyable"
        :title="copiedKey === 'id' ? 'Скопировано' : 'Скопировать ID'"
        @click.stop="copyValue(item.id, 'id')"
      >{{ item.id }}</button>
      <span v-else class="hub-preview-value">—</span>
    </div>
    <div v-for="row in rows" :key="row.key" class="hub-preview-row">
      <span class="hub-preview-key">{{ row.label }}</span>
      <button
        v-if="row.value"
        type="button"
        class="hub-preview-value copyable"
        :title="copiedKey === row.key ? 'Скопировано' : `Скопировать ${row.label}`"
        @click.stop="copyValue(row.value, row.key)"
      >{{ row.value }}</button>
      <span v-else class="hub-preview-value">—</span>
    </div>
  </div>
  <p v-else class="hub-preview-empty">{{ emptyText }}</p>
</template>

<script>
import { computed, onBeforeUnmount, ref } from 'vue'

const formatDriverName = (item) =>
  item.full_name || [item.last_name, item.first_name, item.surname].filter(Boolean).join(' ')

const shortCompanyName = (name) => {
  if (!name) return ''
  return String(name).replace(/^ИП\s+/i, '').trim()
}

export default {
  name: 'ExecutorHubPreview',
  props: {
    model: { type: String, required: true },
    item: { type: Object, default: null },
    showId: { type: Boolean, default: false },
    emptyText: { type: String, default: 'Не назначено' },
  },
  setup(props) {
    const copiedKey = ref('')
    let copiedTimer = null
    const rows = computed(() => {
      const item = props.item || {}
      const definitions = {
        companies: [
          ['name', 'Название', shortCompanyName(item.name)],
          ['inn', 'ИНН', item.inn],
          ['ogrn', 'ОГРН', item.ogrn],
          ['director', 'Директор', item.director],
        ],
        managers: [
          ['name', 'Имя', item.name],
          ['phone', 'Телефон', item.phone],
          ['email', 'Email', item.email],
        ],
        drivers: [
          ['full_name', 'ФИО', formatDriverName(item)],
          ['phone', 'Телефон', item.phone],
          ['passport', 'Паспорт', item.passport],
          ['license', 'ВУ', item.license],
        ],
        cars: [
          ['number', 'Номер', item.number],
          ['vin', 'VIN', item.vin],
          ['imei', 'IMEI', item.imei],
          ['ownerPhone', 'Владелец', item.ownerPhone],
        ],
        trailers: [
          ['number', 'Номер', item.number],
          ['vin', 'VIN', item.vin],
        ],
      }
      return (definitions[props.model] || []).map(([key, label, value]) => ({
        key,
        label,
        value,
        title: key === 'vin' ? value : undefined,
      }))
    })

    const copyValue = async (value, key) => {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(String(value))
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = String(value)
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          textarea.remove()
        }
        copiedKey.value = key
        clearTimeout(copiedTimer)
        copiedTimer = setTimeout(() => { copiedKey.value = '' }, 1200)
      } catch (_error) {
        copiedKey.value = ''
      }
    }

    onBeforeUnmount(() => clearTimeout(copiedTimer))

    return { rows, copiedKey, copyValue }
  },
}
</script>

<style scoped>
.hub-preview {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hub-preview-row {
  align-items: baseline;
  display: flex;
  gap: 8px;
}

.hub-preview-key {
  color: #6b7280;
  flex: 0 0 92px;
  font-size: 12px;
  font-weight: 600;
}

.hub-preview-value {
  color: #111827;
  font-size: 13px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.copyable {
  background: transparent;
  border: 0;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-align: left;
}

.copyable:hover {
  color: #2563eb;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.hub-preview-empty {
  color: #9ca3af;
  font-size: 13px;
  margin: 0;
}
</style>
